import React from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './footerStyle'
import InstagramIcon from '@material-ui/icons/Instagram'
import FacebookIcon from '@material-ui/icons/Facebook'
import { useSelector } from 'react-redux'


export default function Footer() {
  const classes = useStyles()
  const socialNetworks = useSelector(state => state.socialNetworks)

  return (
    <div className={classes.root}>
            
      <p><a href="http://www.alithya.com" target="_blank">© ALITHYA 2022</a></p>
      <p><a target="_blank" href="/documents/reglement-interieur.pdf">REGLEMENT DU CLUB</a></p>
      <p><Link to="/donnees-personnelles">POLITIQUE DE CONFIDENTIALITE</Link></p>
      <p><Link to="/donnees-personnelles">CONDITIONS D'UTILISATION</Link></p>
      <div className={classes.social} >
        <p><a href={socialNetworks?.instagram} target="_blank"><InstagramIcon/></a></p>
        <p><a href={socialNetworks?.facebook} target="_blank"><FacebookIcon/></a></p>
        <p><a href={socialNetworks?.nicefr} target="_blank"><img width="20" src="/ville-nice-white-logo.png" /></a></p>
        <p><a href={socialNetworks?.spectacle} target="_blank"><img width="20" src="/theater-icon.png" /></a></p>
      </div>
    </div>
  )
}
